<!-- Modal backdrop con animación de fade -->
@if (modalConfirmLogoutService.isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center transition-opacity duration-300 ease-in-out overflow-y-auto py-10"
    [class.animate-fadeOut]="(modalConfirmLogoutService.isClosing$ | async)"
    (click)="closeModal()"
    >
    <!-- Contenedor del modal con animación de entrada y salida -->
    <div
      class="bg-white rounded-lg shadow-md w-11/12 sm:w-10/12 md:w-8/12 lg:w-6/12 max-w-md mx-auto z-50 overflow-hidden transform transition-all duration-300 ease-in-out"
      [class.animate-fadeOut]="(modalConfirmLogoutService.isClosing$ | async)"
      (click)="$event.stopPropagation()"
      >
      <!-- Cabecera del modal -->
      <div
        class="px-4 sm:px-6 py-3 sm:py-4 border-b border-amber-300 flex justify-between items-center bg-amber-400"
        >
        <h3 class="text-base sm:text-lg font-medium text-black">Cerrar sesión</h3>
        <button
          (click)="closeModal()"
          class="text-black hover:text-gray-800 focus:outline-none transition-transform duration-300 hover:scale-110"
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.5"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <!-- Contenido del modal -->
        <div class="p-4 sm:p-6">
          <div class="text-center mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-12 w-12 mx-auto text-amber-500 mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              <h4 class="text-lg font-medium text-gray-900 mb-2">¿Estás seguro?</h4>
              <p class="text-gray-600">¿Realmente deseas cerrar tu sesión actual?</p>
            </div>
            <div class="flex flex-col sm:flex-row justify-center gap-3 mt-6">
              <button
                (click)="closeModal()"
                class="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors duration-300 font-medium"
                >
                Cancelar
              </button>
              <button
                (click)="confirmLogout()"
                class="px-4 py-2 bg-amber-400 text-white rounded-md hover:bg-amber-500 transition-colors duration-300 font-medium"
                >
                Sí, cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    }
